<ng-container *ngIf="viewModel$ | async as vm">
  <app-home-mode-end-date-edition
    *ngIf="displayEndDate(
      vm.thermMode,
      vm.coolingMode,
      vm.autoTempMode,
      vm.temperatureControlMode
    )">
  </app-home-mode-end-date-edition>
</ng-container>

